"use client";

import OnlineUsers from "@/components/shared/online-users";
import { useChat } from "@/providers/chat-provider";
import { useCommunityContext } from "@/providers/community-provider";
import { ChevronsLeftIcon } from "lucide-react";
import { useEffect, useState } from "react";
import CommunityMembers from "./members";
import { useResponsive } from "@/hooks/useResponsive";

const RightSidebar = () => {
	const { showChatWidget } = useChat();
	const [minimized, setMinimized] = useState(false);
	const { isSidebarMinimized, handleMinimizeSidebar } = useCommunityContext();
	const { matchesCustom: isWideDesktop } = useResponsive("(min-width: 1920px)");

	useEffect(() => {
		const minimize = !isSidebarMinimized && showChatWidget && !isWideDesktop;

		setMinimized(minimize);
	}, [isSidebarMinimized, showChatWidget, isWideDesktop]);

	const handleMinimize = () => {
		if (!isSidebarMinimized && showChatWidget) {
			handleMinimizeSidebar();
			setMinimized(false);
		} else {
			setMinimized(false);
		}
	};

	return minimized ? (
		<button type="button" className="rounded-lg bg-white p-2 shadow" onClick={handleMinimize}>
			<ChevronsLeftIcon className="h-5 w-5 stroke-2 text-brand-primary" />
		</button>
	) : (
		<div className="hidden min-w-[300px] max-w-[350px] space-y-4 md:block">
			<OnlineUsers />
			<CommunityMembers />
		</div>
	);
};

export default RightSidebar;
